<template>
  <div class="orders">
    <template v-if="!branchNotFound">
      <v-data-table
        :fixed-header="true"
        :headers="headers"
        :items="orders"
        item-key="id"
        class="elevation-1"
        height="65vh"
        :items-per-page="50"
        :footer-props="{
          'items-per-page-options': [50]
        }"
        :loading="isLoadingOrders"
        loading-text="Loading Orders... Please wait"
        :search="search"
      >
        <template v-slot:top>
          <div class="d-flex">
            <v-spacer></v-spacer>

            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              filled
              clearable
            ></v-text-field>
          </div>

          <v-divider></v-divider>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn
            class="showLink"
            text
            :ripple="false"
            :to="{ name: 'order', params: { orderId: item.id } }"
          >
            <v-icon color="primary lighten-1">mdi-arrow-expand</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.status="{ item }">
          <v-btn
            v-if="item.is_pending"
            :disabled="isStaff"
            @click="unsetPendingOrder(item)"
            icon
            :loading="item.isLoadingOrder"
          >
            <v-icon color="grey">mdi-sync</v-icon>
          </v-btn>

          <v-icon v-else color="primary darken-4">mdi-printer-pos</v-icon>
        </template>
      </v-data-table>

      <v-fab-transition>
        <v-btn
          v-if="isAuthorized2"
          v-show="isSmaller"
          dark
          color="primary darken-4"
          fixed
          bottom
          right
          fab
          @click="makeNewOrder()"
        >
          <v-icon large>mdi-file-document-edit</v-icon>
        </v-btn>
      </v-fab-transition>
    </template>

    <v-container v-else>
      <v-row justify="center" align="center">
        <v-col cols="auto">
          <v-card color="white" class="pa-8" light elevation="2" :width="cardWidth">
            <div class="d-flex justify-center grey--text">
              <v-icon size="150">mdi-cancel</v-icon>
            </div>

            <div class="text-center title grey--text">
              <span class="font-weight-black">Branch</span> not available
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "Orders",
  data() {
    return {
      search: "",
      isLoadingOrders: false,
      headers: [
        { text: "", value: "actions", sortable: false },
        { text: "Name", align: "start", value: "name" },
        { text: "Client Phone", value: "client_phone" },
        { text: "Status", value: "status" },
        { text: "Attendant", value: "attendant" },
        { text: "Modified", value: "modified" },
        { text: "Total (GH₵)", value: "amount_payable" },
        { text: "Created", value: "created" },
        { text: "Branch", value: "branch" },
        { text: "Vendor", value: "vendor" }
      ],
      updater: null
    };
  },

  methods: {
    async getOrders() {
      var branchId = this.$route.params.branchId;

      this.isLoadingOrders = true;

      await this.$store.dispatch("getOrders", branchId).finally(() => {
        this.isLoadingOrders = false;
      });
    },

    async unsetPendingOrder(order) {
      Vue.set(order, "isLoadingOrder", true);

      await this.$store
        .dispatch("readyOrder", order.id)
        .then(() => {})
        .catch(error => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.getOrders();
        });
    },

    async getProforma(orderId) {
      await this.$store
        .dispatch("getProforma", orderId)
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.getOrders();
        });
    },

    makeNewOrder() {
      this.$store.dispatch("makeNewOrder");
    }
  },

  watch: {
    $route() {
      this.getOrders();
    }
  },

  beforeRouteLeave(to, from, next) {
    clearInterval(this.updater);
    this.$store.commit("setBranchVendor");
    this.$store.commit("setOnBranch");
    next();
  },

  mounted() {
    this.getOrders();

    this.updater = setInterval(() => {
      this.getOrders();
    }, 10000);
  },

  computed: {
    isSmaller() {
      var name = this.$vuetify.breakpoint.name;

      if (name === "xs" || name === "sm") return true;
      else return false;
    },

    orders() {
      var orders_data = JSON.stringify(this.$store.state.orders.orders);
      var orders = JSON.parse(orders_data);

      for (var order of orders) {
        Vue.set(order, "isLoadingOrder", false);
      }

      return orders;
    },

    branchNotFound() {
      return this.$store.state.branches.branchNotFound;
    },

    isStaff() {
      if (this.$store.state.user.user_type === "Staff") {
        if (this.$store.state.user.is_privileged) return false;
        return true;
      }
      return false;
    },

    cardWidth() {
      var name = this.$vuetify.breakpoint.name;

      if (name === "xs") {
        return "99vw";
      } else {
        return "45vw";
      }
    },

    isAuthorized2() {
      return this.$store.getters.isAuthorized2;
    }
  }
};
</script>

<style scoped>
.showLink:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>